export enum FeatureFlags {
  SITE_BRAND = 'SITE_BRAND',
}
